import { render } from "./statsModal.vue?vue&type=template&id=3feb911f&scoped=true"
import script from "./statsModal.vue?vue&type=script&lang=js"
export * from "./statsModal.vue?vue&type=script&lang=js"

import "./statsModal.vue?vue&type=style&index=0&id=3feb911f&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feb911f"]])

export default __exports__